// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"2be7605a","312":"2fa50d85","483":"3f221b4e","640":"94e985d6","828":"b38aace6"}[chunkId] + ".chunk.js";
};